import React, { useRef, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate } from 'react-router-dom'
import { SuccessfullyModal } from '../../components/Modals/Modals';
import endPoints from '../../Repository/apiConfig';
import { postApi } from '../../Repository/Api';
import { RiImageAddLine } from "react-icons/ri";


const AddVouchersOffers = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [coupontitle, setCouponTitle] = useState('');
    const [image, setImage] = useState('');
    const [percentage, setPercentage] = useState('');
    const [discount, setDiscount] = useState('');
    const [activedate, setActiveDate] = useState('');
    const [expriredate, setExprireDate] = useState('');
    const [description, setDescription] = useState('');
    const [imagePreview, setImagePreview] = useState(null);

    const fileInputRef = useRef(null);


    const handleSubmit = async () => {

        const formData = new FormData();
        formData.append('title', coupontitle);
        formData.append('image', image);
        formData.append('discount', discount);
        formData.append('activationDate', activedate);
        formData.append('expirationDate', expriredate);
        formData.append('description', description);
        formData.append('per', percentage);


        await postApi(endPoints.addcoupon, formData, {
            setLoading,
            successMsg: 'Voucher & Offers added successfully!',
            errorMsg: 'Failed to add voucher & Offers!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/voucher-Offers'); // Redirect to the Privacy Policy list page
        }, 2000);
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleUploadClick = () => fileInputRef.current?.click();

    const handleClearImage = () => {
        setImage(null);
        setImagePreview(null);
    };

    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Created"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Add Vouchers & Offers</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
                            <p>View Vouchers & Offers</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Offer Details</h6>
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Create Offer Name*</label>
                            <input
                                type="text"
                                placeholder='name'
                                value={coupontitle}
                                onChange={(e) => setCouponTitle(e.target.value)}
                            />
                        </div>
                        {/* <div className={addjob.addjobinputs}>
                            <label htmlFor="">Code*</label>
                            <input
                                type="text"
                                placeholder='code'
                                value={couponcode}
                                onChange={(e) => setCouponCode(e.target.value)}
                            />
                        </div> */}
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Choose Discount Type*</label>
                            <select
                                onChange={(e) => setPercentage(e.target.value)}
                                value={percentage}
                            >
                                <option value="">Select</option>
                                <option value="Percentage">Percentage</option>
                                <option value="Amount">Amount</option>
                            </select>
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Discount*</label>
                            <input
                                type="text"
                                placeholder='discount'
                                value={discount}
                                onChange={(e) => setDiscount(e.target.value)}
                            />
                        </div>
                        <div className={addjob.addbannercontainer}>
                            <label htmlFor="">Coupon Image*</label>
                            <div className={addjob.addbannerinput}>
                                {imagePreview ? (
                                    <>
                                        <div className={addjob.editbannerimage}>
                                            <img src={imagePreview} alt="" />
                                        </div>
                                        <span onClick={handleClearImage}>Clear</span>
                                    </>
                                ) : (
                                    <>
                                        <div className={addjob.addbannerupload} onClick={handleUploadClick}>
                                            <RiImageAddLine color='#8D98AA' size={35} />
                                            <p>Upload your file</p>
                                        </div>
                                        <span>Max 2MB</span>
                                    </>
                                )}
                            </div>
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                hidden
                            />
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Description*</label>
                            <textarea
                                placeholder='description'
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </div>
                        <div className={addjob.addnewbanner}>
                            <div className={addjob.addjobtopic}>
                                <h6>Validity</h6>
                            </div>
                            <div className={addjob.addvouchercontainer}>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Start Date *</label>
                                    <input
                                        type="date"
                                        value={activedate}
                                        onChange={(e) => setActiveDate(e.target.value)}
                                    />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">End Date*</label>
                                    <input
                                        type="date"
                                        value={expriredate}
                                        onChange={(e) => setExprireDate(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button
                                onClick={handleSubmit}
                                style={{ background: '#F05423' }}
                                disabled={loading}
                            >
                                {loading ? "Adding..." : "Add"}
                            </button>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default HOC(AddVouchersOffers)